import Config from "../../config";

export const getVoList = (host: string, token: string) => {
  const reqestURL = `${host}/${Config.version}/jetstream/vo`;
  const reqestHeader: HeadersInit = new Headers();
  reqestHeader.set("Content-Type", "application/json");
  reqestHeader.set("Authorization", `Bearer ${token}`);

  return fetch(reqestURL, {
    method: "GET",
    headers: reqestHeader
  })
    .then(response => response.json())
    .then(response => {
      if (response.status.code === 200) {
        return response.data ? response.data : new Array();
      } else {
        return response;
      }
    })
    .catch((error: any) => error);
};

export const getStorageList = (host: string, token: string, vo: string) => {
  const reqestURL = `${host}/${Config.version}/jetstream/${vo}/storages`;
  const reqestHeader: HeadersInit = new Headers();
  reqestHeader.set("Content-Type", "application/json");
  reqestHeader.set("Authorization", `Bearer ${token}`);

  return fetch(reqestURL, {
    method: "GET",
    headers: reqestHeader
  })
    .then(response => response.json())
    .then(response => {
      if (response.status.code === 200) {
        return response.data ? response.data : new Array();
      } else {
        return response;
      }
    })
    .catch((error: any) => error);
};

export const getStorageFieldsList = (
  host: string,
  token: string,
  vo: string,
  storage: string
) => {
  const reqestURL = `${host}/${
    Config.version
    }/jetstream/${vo}/storages/${storage}/fields`;
  const reqestHeader: HeadersInit = new Headers();
  reqestHeader.set("Content-Type", "application/json");
  reqestHeader.set("Authorization", `Bearer ${token}`);

  return fetch(reqestURL, {
    method: "GET",
    headers: reqestHeader
  })
    .then(response => response.json())
    .then(response => {
      if (response.status.code === 200) {
        return response.data ? response.data : new Array();
      } else {
        return response;
      }
    })
    .catch((error: any) => error);
};

export const getLastObjectList = (
  host: string,
  token: string,
  vo: string,
  storage: string,
  limit: number
) => {
  const reqestURL = `${host}/${
    Config.version
    }/jetstream/${vo}/storages/${storage}/objects?last=${limit}`;
  const reqestHeader: HeadersInit = new Headers();
  reqestHeader.set("Content-Type", "application/json");
  reqestHeader.set("Authorization", `Bearer ${token}`);

  return fetch(reqestURL, {
    method: "GET",
    headers: reqestHeader
  })
    .then(response => response.json())
    .then(response => {
      if (response.status.code === 200) {
        return response.data ? response.data : new Array();
      } else {
        return response;
      }
    })
    .catch((error: any) => error);
};
